<template>
  <div>
    <div class="section1 safe-area">
      <pageTitle cn="课件下载" en="Courseware Download" type="1"></pageTitle>
      <div class="page-flex-lr-center">
        <div class="lf">
          <div class="common-title-d1 mt-20">获取PBL备课资料，覆盖选题指导、调研方法、答辩训练、手工创作、舞台剧编排全流程。</div>
          <div class="common-title-d2 mt-12">Access PBL lesson planning materials covering the entire process, from topic selection guidance and research methods to defense practice, hands-on projects, and stage production.</div>
          <!-- <div class="page-btn mt-20">
            <div class="cn">点击下载</div>
            <div class="en">Click to download</div>
          </div> -->
        </div>
        <div class="rt">
          <img :src="$env.imgUrl + 'study3-s1.png'" alt="">
        </div>
      </div>
    </div>
    <div class="section2" :style="'background-image: url(' + $env.imgUrl + 'pbl-bg-1.png);'">
      <div class="safe-area page-flex-lr-center">
        <div class="lf">
          <pageTitle cn="教师培训" en="Teacher Training" type="2"></pageTitle>
          <div class="common-title-d3 mt-20">为确保参赛教师能够有效指导学生完成项目，参赛队伍可在备赛期间与组委会预约赛前教师培训。培训内容涵盖从选题立项、组建战队、到成果展示的全流程方法。</div>
          <div class="common-title-d4 mt-12">To ensure that participating teachers can effectively guide their students in completing their projects, teams may schedule pre-competition teacher training sessions with the organizing committee during the preparation period. The training covers the entire process, from selecting a topic and launching a project to forming a team and presenting the final results.</div>
          <!-- <div class="page-btn page-btn2 mt-20">
            <div class="cn">点击下载</div>
            <div class="en">Click to download</div>
          </div> -->
        </div>
        <div class="rt">
          <img :src="$env.imgUrl + 'study3-s2.png'" alt="">
        </div>
      </div>
    </div>
    <div class="section3">
      <div class="safe-area">
        <div class="page-flex-lr-center-between">
          <div class="lf">
            <pageTitle cn="资源共享" en="Resource Share" type="1"></pageTitle>
            <div class="common-title-d1 mt-20">开放教案上传端口，全国一线教师互通原创教学方案、课堂实践案例，共建共享PBL教学资源库。</div>
            <div class="common-title-d2 mt-12">Open a portal for uploading lesson plans, enabling frontline teachers nationwide to share original teaching plans and classroom case studies, and to collaboratively build and share a PBL teaching resource repository.</div>
            <!-- <div class="page-btn mt-20">
              <div class="cn">点击上传</div>
              <div class="en">Click to upload</div>
            </div> -->
          </div>
          <div class="rt">
            <img :src="$env.imgUrl + 'study3-s3.png'" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  }
}
</script>
<style scoped lang="less">
.mt-20{
  margin-top: 20px;
}
.section1{
  padding: 30px 0 40px;
  .lf{
    width: 45%;
  }
  .rt{
    flex: 1;
    margin-left: 20px;
    img{
      width: 100%;
    }
  }
}
.section2{
  padding: 80px 0;
  margin-bottom: 10px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .lf{
    width: 45%;
  }
  .rt{
    flex: 1;
    margin-left: 20px;
  }
}
.section3 {
  padding: 20px 0 60px;
  .lf{
    width: 45%;
  }
  .rt{
    flex: 1;
    margin-left: 20px;
  }
}
</style>
